export default __webpack_public_path__ + "static/media/meditate.1a4c8909.svg";